import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useAuthContext } from '../contexts/authContext';
import PublicRoute from './publicRoute';
import PrivateRoute from './privateRoute';
import {
    EXPIRATIONTOKEN,
    HOME,
    SIGNIN,
    REDIRECTLIST,
    REDIRECTNEW,
    REDIRECTEDIT,
    USERS,
    USERLIST,
    USERNEW,
    USEREDIT,
    PAGENOTFOUND,
    CHATVIDEO,
    CHAT,
    EXPORT,
    MODULES,
    ACCOUNTS,
    ACCOUNTS_NEW,
    ACCOUNTS_EDIT,
    PQR,
    ACCOUNTS_DETAIL,
    PQR_EDIT,
    PQR_DETAIL,
    PQR_HISTORY,
    INITIAL_CAUSALITY,
    INITIAL_CAUSALITY_NEW,
    INITIAL_CAUSALITY_EDIT,
    INITIAL_CAUSALITY_DETAIL,
    SARLAFT,
    SARLAFT_EDIT,
    SARLAFT_DETAIL,
    PQRWEB,
    ALERTS,
    ALERTS_NEW,
    CASES_GENERAL_INFORMATION,
    CASES_GENERAL_INFORMATION_DETAIL,
    CASES_GENERAL_INFORMATION_EDIT,
    PQRWEB_CREATE,
    PQRWEB_SEARCH,
    PQRWEB_SURVEY,
    CASES_GENERAL,
    CASES_GENERAL_EDIT,
    CASES_GENERAL_DETAIL,
    PQR_MANAGEMENT,
    LEGAL_PROCEEDINGS,
    LEGAL_PROCEEDINGS_NEW,
    LEGAL_PROCEEDINGS_EDIT,
    LEGAL_PROCEEDINGS_DETAIL,
    ALERTS_EDIT,
    ALERTS_DETAIL,
    SAMPLES,
    SAMPLES_DETAIL,
    SAMPLES_EDIT,
    PQRWEB_SURVEY_RESPONSE,
    TYPIFICATIONS,
    FINAL_CAUSALITY,
    FINAL_CAUSALITY_NEW,
    FINAL_CAUSALITY_EDIT,
    FINAL_CAUSALITY_DETAIL,
    CHANNELSSMSFORM,
    CHANNELSMSFORMTHANKYOU,
    SYSTEMCONFIG,
    MOTIVE,
    MOTIVE_NEW,
    MOTIVE_EDIT,
    MOTIVE_DETAIL,
    REDIRECT_DETAIL,
    PQR_SURVEY_DETAIL,
    // CASES_GENERAL_CREATE,
} from './paths';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
import variables from '../shared/styles/settings.module.scss';
import SignIn from '../components/pages/auth/signIn';
import Home from '../components/pages/home/home';
import { Users } from '../components/pages/users';
import UserNew from '../components/pages/users/new';
import EditUser from '../components/pages/users/edit';
import ExpirationToken from '../components/components/views/expirationToken';
import PageNotFound from '../components/components/views/pageNotFound';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import ChatVideo from '../components/pages/chatvideo/chat';
import ChatWeb from '../components/pages/chatWeb/chat';
import Export from '../components/pages/export/export';
import { Accounts } from '../components/pages/modules/accounts';
import { AccountForm } from '../components/pages/modules/accounts/form';
import { Pqr } from '../components/pages/modules/pqr';
import { AccountDetail } from '../components/pages/modules/accounts/detail';
import { PqrDetail } from '../components/pages/modules/pqr/detail';
import { PqrFormEdit } from '../components/pages/modules/pqr/formEdit';
import { Sarlaft } from '../components/pages/modules/sarlaft';
import { SarlaftForm } from '../components/pages/modules/sarlaft/form';
import { SarlaftDetail } from '../components/pages/modules/sarlaft/detail';
import { PqrWeb } from '../components/pages/modules/pqr_web';
import { CasesGeneralInformation } from '../components/pages/modules/casesGeneralInformation';
import { CasesGeneralInformationDetail } from '../components/pages/modules/casesGeneralInformation/detail';
import { CasesGeneralInformationForm } from '../components/pages/modules/casesGeneralInformation/form';
import { PqrWebCreate } from '../components/pages/modules/pqr_web/form';
import { PqrFiltersWeb } from '../components/pages/modules/pqr_web/filters';
import { CasesGeneral } from '../components/pages/modules/casesGeneral';
import { CasesGeneralForm } from '../components/pages/modules/casesGeneral/form';
import { CaseGeneralDetail } from '../components/pages/modules/casesGeneral/detail';
import { RedirectParams } from '../components/pages/systemConfig/redirectParams';
import { RedirectPqrForm } from '../components/pages/systemConfig/redirectParams/form';
import { RedirectPqrDetail } from '../components/pages/systemConfig/redirectParams/detail';
import { LegalProceedings } from '../components/pages/pqrManagement/legalProceedings';
import { LegalProceedingsForm } from '../components/pages/pqrManagement/legalProceedings/form';
import { LegalProceedingsDetail } from '../components/pages/pqrManagement/legalProceedings/detail';
import { AlertsForm } from '../components/pages/pqrManagement/alert/form';
import { Alerts } from '../components/pages/pqrManagement/alert';
import { AlertsDetail } from '../components/pages/pqrManagement/alert/detail';
import { Samples } from '../components/pages/pqrManagement/samples';
import { PqrSurveyForm } from '../components/pages/modules/pqr_web/survey';
import { PqrHistory } from '../components/pages/modules/pqr_history';
import { InitialCausality } from '../components/pages/typifications/initialCausality';
import { InitialCausalityForm } from '../components/pages/typifications/initialCausality/form';
import { InitialCausalityDetail } from '../components/pages/typifications/initialCausality/detail';
import { FinalCausality } from '../components/pages/typifications/finalCausality';
import { FinalCausalityForm } from '../components/pages/typifications/finalCausality/form';
import { FinalCausalityDetail } from '../components/pages/typifications/finalCausality/detail';
import { ChannelsWeb } from '../components/pages/modules/updateChannelsSms';
import { ChannelsWebThankYou } from '../components/pages/modules/updateChannelsSms/info';
import { MotiveForm } from '../components/pages/systemConfig/motives/form';
import { Motive } from '../components/pages/systemConfig/motives';
import { MotiveDetail } from '../components/pages/systemConfig/motives/detail';
import { PqrSurveyDetail } from '../components/pages/modules/pqr/surveyDetail';

const AppRoutes = () => {
    const { modeTheme } = useAuthContext();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const theme = createTheme(
        {
            palette:
                modeTheme === 'darkMode'
                    ? {
                        // palette values for dark mode
                        primary: {
                            main: variables.darkColor,
                            contrastText: variables.whiteColor,
                            dark: variables.greyColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                    }
                    : {
                        // palette values for light mode
                        primary: {
                            main: variables.primaryColor,
                            contrastText: variables.whiteColor,
                            dark: variables.quinaryColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                    },
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 500,
                    md: 800,
                    lg: 1200,
                    xl: 1536,
                },
            },
        },
        esES
    );

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path={HOME} element={<PrivateRoute />}>
                        <Route index element={<Home />} />
                    </Route>
                    <Route path={MODULES} element={<PrivateRoute />}>
                        <Route
                            path={`${ACCOUNTS}/:documentAccount?`}
                            element={<Accounts />}
                        />
                        <Route path={ACCOUNTS_NEW} element={<AccountForm />} />
                        {[
                            'admin',
                            'backoffice',
                            'agent',
                            'supervisor',
                        ].includes(type) && (
                            <Route
                                path={`${ACCOUNTS_EDIT}/:idAccount`}
                                element={<AccountForm />}
                            />
                        )}
                        <Route
                            path={`${ACCOUNTS_DETAIL}/:idAccount`}
                            element={<AccountDetail />}
                        />
                        <Route path={`${PQR}/:pqrId?`} element={<Pqr />} />
                        {['admin', 'backoffice', 'supervisor'].includes(
                            type
                        ) && (
                            <Route
                                path={`${PQR_EDIT}/:idPqr`}
                                element={<PqrFormEdit showFormView />}
                            />
                        )}
                        <Route
                            path={`${PQR_DETAIL}/:idPqr`}
                            element={<PqrDetail samples={false} />}
                        />
                        <Route
                            path={`${PQR_SURVEY_DETAIL}/:idPqr`}
                            element={<PqrSurveyDetail />}
                        />
                        <Route path={PQR_HISTORY} element={<PqrHistory />} />

                        <Route
                            path={`${SARLAFT}/:sarlaftId?`}
                            element={<Sarlaft />}
                        />
                        {['admin', 'backoffice'].includes(type) && (
                            <Route
                                path={`${SARLAFT_EDIT}/:idSarlaft`}
                                element={<SarlaftForm showFormView />}
                            />
                        )}
                        <Route
                            path={`${SARLAFT_DETAIL}/:idSarlaft`}
                            element={<SarlaftDetail />}
                        />
                        <Route
                            path={`${CASES_GENERAL_INFORMATION}`}
                            element={<CasesGeneralInformation />}
                        />
                        {['admin', 'backoffice'].includes(type) && (
                            <Route
                                path={`${CASES_GENERAL_INFORMATION_EDIT}/:idCasesGeneralInformation`}
                                element={
                                    <CasesGeneralInformationForm showFormView />
                                }
                            />
                        )}
                        <Route
                            path={`${CASES_GENERAL_INFORMATION_DETAIL}/:idCasesGeneralInformation`}
                            element={<CasesGeneralInformationDetail />}
                        />
                        <Route
                            path={`${CASES_GENERAL}`}
                            element={<CasesGeneral />}
                        />
                        {['admin', 'backoffice'].includes(type) && (
                            <Route
                                path={`${CASES_GENERAL_EDIT}/:idCasesGeneral`}
                                element={<CasesGeneralForm showFormView />}
                            />
                        )}
                        <Route
                            path={`${CASES_GENERAL_DETAIL}/:idCasesGeneral`}
                            element={<CaseGeneralDetail />}
                        />
                    </Route>
                    <Route path={PQR_MANAGEMENT} element={<PrivateRoute />}>
                        <Route
                            path={LEGAL_PROCEEDINGS}
                            element={<LegalProceedings />}
                        />
                        <Route
                            path={LEGAL_PROCEEDINGS_NEW}
                            element={<LegalProceedingsForm showFormView />}
                        />
                        {['admin', 'backoffice', 'supervisor'].includes(
                            type
                        ) && (
                            <Route
                                path={`${LEGAL_PROCEEDINGS_EDIT}/:idLegalProceeding`}
                                element={<LegalProceedingsForm showFormView />}
                            />
                        )}
                        <Route
                            path={`${LEGAL_PROCEEDINGS_DETAIL}/:idLegalProceeding`}
                            element={<LegalProceedingsDetail />}
                        />
                        <Route path={ALERTS} element={<Alerts />} />
                        <Route
                            path={`${ALERTS_NEW}/:arrayPqr?`}
                            element={<AlertsForm showFormView />}
                        />
                        {['admin', 'backoffice', 'supervisor'].includes(
                            type
                        ) && (
                            <Route
                                path={`${ALERTS_EDIT}/:idAlert`}
                                element={<AlertsForm showFormView />}
                            />
                        )}
                        <Route
                            path={`${ALERTS_DETAIL}/:idAlert`}
                            element={<AlertsDetail />}
                        />
                        <Route path={SAMPLES} element={<Samples />} />
                        {['admin', 'backoffice', 'supervisor'].includes(
                            type
                        ) && (
                            <Route
                                path={`${SAMPLES_EDIT}/:idPqr`}
                                element={<PqrFormEdit showFormView isSample />}
                            />
                        )}
                        <Route
                            path={`${SAMPLES_DETAIL}/:idPqr`}
                            element={<PqrDetail samples={true} />}
                        />
                    </Route>
                    <Route path={TYPIFICATIONS} element={<PrivateRoute />}>
                        <Route
                            path={FINAL_CAUSALITY}
                            element={<FinalCausality />}
                        />
                        <Route
                            path={FINAL_CAUSALITY_NEW}
                            element={<FinalCausalityForm />}
                        />
                        {['admin', 'backoffice', 'supervisor'].includes(
                            type
                        ) && (
                            <Route
                                path={`${FINAL_CAUSALITY_EDIT}/:idFinalCausality`}
                                element={<FinalCausalityForm />}
                            />
                        )}
                        <Route
                            path={`${FINAL_CAUSALITY_DETAIL}/:idFinalCausality`}
                            element={<FinalCausalityDetail />}
                        />
                    </Route>
                    <Route path={TYPIFICATIONS} element={<PrivateRoute />}>
                        <Route
                            path={INITIAL_CAUSALITY}
                            element={<InitialCausality />}
                        />
                        <Route
                            path={INITIAL_CAUSALITY_NEW}
                            element={<InitialCausalityForm />}
                        />
                        {['admin', 'backoffice', 'supervisor'].includes(
                            type
                        ) && (
                            <Route
                                path={`${INITIAL_CAUSALITY_EDIT}/:idInitialCausality`}
                                element={<InitialCausalityForm />}
                            />
                        )}
                        <Route
                            path={`${INITIAL_CAUSALITY_DETAIL}/:idInitialCausality`}
                            element={<InitialCausalityDetail />}
                        />
                    </Route>
                    {['admin', 'supervisor', 'formador', 'calidad'].includes(
                        type
                    ) && (
                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route
                                path={REDIRECTLIST}
                                element={<RedirectParams />}
                            />
                            {['admin', 'supervisor'].includes(type) && (
                                <>
                                    <Route
                                        path={REDIRECTNEW}
                                        element={<RedirectPqrForm />}
                                    />
                                    <Route
                                        path={`${REDIRECTEDIT}/:idRedirect`}
                                        element={<RedirectPqrForm />}
                                    />
                                    <Route
                                        path={`${REDIRECT_DETAIL}/:idRedirect`}
                                        element={<RedirectPqrDetail />}
                                    />
                                </>
                            )}
                        </Route>
                    )}
                    {type == 'admin' && (
                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={MOTIVE} element={<Motive />} />

                            <Route path={MOTIVE_NEW} element={<MotiveForm />} />
                            <Route
                                path={`${MOTIVE_EDIT}/:name/:active`}
                                element={<MotiveForm />}
                            />
                            <Route
                                path={`${MOTIVE_DETAIL}/:name/:active`}
                                element={<MotiveDetail />}
                            />
                        </Route>
                    )}
                    <Route path={USERS} element={<PrivateRoute />}>
                        {['admin', 'supervisor'].includes(type) && (
                            <Route path={USERLIST} element={<Users />} />
                        )}
                        {type === 'admin' && (
                            <>
                                <Route path={USERNEW} element={<UserNew />} />
                                <Route
                                    path={`${USEREDIT}/:idUser`}
                                    element={<EditUser />}
                                />
                            </>
                        )}
                    </Route>
                    {type === 'admin' && (
                        <Route element={<PrivateRoute />}>
                            <Route path={EXPORT} element={<Export />} />
                        </Route>
                    )}
                    <Route path={SIGNIN} element={<PublicRoute />}>
                        <Route index element={<SignIn />} />
                        <Route
                            path={EXPIRATIONTOKEN}
                            element={<ExpirationToken />}
                        />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route path={CHATVIDEO} element={<ChatVideo />} />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route path={CHAT} element={<ChatWeb />} />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route path={PQRWEB} element={<PqrWeb />} />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route
                            path={PQRWEB_CREATE}
                            element={<PqrWebCreate />}
                        />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route
                            path={PQRWEB_SEARCH}
                            element={<PqrFiltersWeb survey={false} />}
                        />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route
                            path={PQRWEB_SURVEY}
                            element={<PqrFiltersWeb survey={true} />}
                        />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route
                            path={`${PQRWEB_SURVEY_RESPONSE}/:idPqr`}
                            element={<PqrSurveyForm />}
                        />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route
                            path={CHANNELSSMSFORM}
                            element={<ChannelsWeb />}
                        />
                    </Route>
                    <Route
                        path={CHANNELSMSFORMTHANKYOU}
                        element={<ChannelsWebThankYou />}
                    />
                    <Route path={PAGENOTFOUND} element={<PageNotFound />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
};

export default AppRoutes;
